import styles from '../../pages/AgentConsolePage.module.css';

interface BannerLoadRetryProps {
  /** The banner slot this stands in for ("Profile", "Model"). */
  label: string;
  /** What failed, in plain words ("agent profiles"). */
  subject: string;
  /** The underlying error text; shown on hover, never as the headline. */
  error: string;
  /** True while a retry cycle is running; disables the button. */
  loading: boolean;
  onRetry: () => void;
}

/**
 * Stand-in for a header-banner picker whose catalog failed to load. Replaces
 * the old silent fallback: the user sees that the picker is missing because a
 * fetch failed, not because there is nothing to pick, and can retry in place
 * instead of reloading the page.
 */
export function BannerLoadRetry({
  label,
  subject,
  error,
  loading,
  onRetry,
}: BannerLoadRetryProps) {
  return (
    <span className={styles.bannerControl} role="alert" title={error}>
      <strong>{label}</strong>
      <span className={styles.bannerLoadError}>Couldn’t load {subject}.</span>
      <button
        type="button"
        className={styles.bannerRetryButton}
        onClick={onRetry}
        disabled={loading}
      >
        {loading ? 'Retrying…' : 'Retry'}
      </button>
    </span>
  );
}
